export default {
    center : {
      lat:39.41228295405807,
      lng:-76.1802292362971
    },
    zoom: {
      google: 8,
      leaflet: 8
    },
    size: {
      google: 100,
      leaflet: 100
    },
    maxZoomForGeoHash: {
      google: 16,
      leaflet: 16
    },
    zoomToPrecision: {
      leaflet : {
        0: 4,
        1: 4,
        2: 4,
        3: 4,
        4: 4,
        5: 4,
        6: 4,
        7: 4,
        8: 4,
        9: 4,
        10: 5,
        11: 5,
        12: 6,
        13: 6,
        14: 7,
        15: 7,
        16: 8,
        17: 8,
        18: 8,
        19: 8,
        20: 8
      }
    },
    boundsToPrecision: {
      google: 6,
      leaflet: 6
    },
  defaultBounds:{
    leaflet: [34.651235232535754, -84.56176757812501, 44.05596804434469, -70.05981445312501]
  }
};
